var _rect, _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#51C394",
    rx: 16,
    transform: "matrix(-1 0 0 1 80 0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.055 33.233q.802.566 4.834 3.36t6.178 4.303q.235.165 1.002.719.766.554 1.273.896.507.343 1.226.766.72.425 1.356.636.636.213 1.179.213h.047q.543 0 1.18-.213.636-.21 1.355-.636.72-.424 1.226-.766.507-.342 1.273-.896.767-.554 1.002-.72 2.17-1.508 11.035-7.662a11.2 11.2 0 0 0 2.876-2.9q1.156-1.698 1.156-3.56 0-1.557-1.12-2.665T57.48 23H22.772q-1.815 0-2.794 1.226Q19 25.452 19 27.29q0 1.486 1.297 3.219t2.758 2.723"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M58.895 36.217q-7.734 5.234-11.742 8.135a56 56 0 0 1-2.181 1.544q-.836.555-2.228 1.132-1.391.577-2.593.577h-.048q-1.202 0-2.594-.577-1.39-.577-2.228-1.132a56 56 0 0 1-2.18-1.544q-3.185-2.334-11.72-8.135A12.5 12.5 0 0 1 19 34.166v18.72q0 1.557 1.108 2.665 1.108 1.11 2.665 1.109H57.48q1.555 0 2.664-1.109 1.108-1.108 1.108-2.664V34.166a13 13 0 0 1-2.358 2.051"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 24,
    r: 5,
    fill: "#F76E6E"
  })));
};
export default SvgMail;